
import filters from '@/filters';

import Vue from 'vue';
import Component from 'vue-class-component';
import { Action, State, Mutation } from 'vuex-class';

import Badge from '@/components/properties/Badge.vue';
import ModalAddSkill from '@/components/candidate/ModalAddSkill.vue';
import PaginationMiniComponent from '@/components/paginations/PaginationMini.vue';
import editCandidate from './InactiveEditCandidate.vue';
import { Watch } from 'vue-property-decorator';

@Component({
  components: {
    Badge,
    ModalAddSkill,
    PaginationMiniComponent,
    editCandidate,
  },
  filters,
})
export default class Inactive extends Vue {

  /* VUEX */

  // ACTION
  @Action('actionSelectCandidateInactive', { namespace: 'candidate' })
  private actionSelectCandidateInactive: any;
  @Action('actionPaginationCandidateInactive', { namespace: 'candidate' })
  private actionPaginationCandidate: any;
  @Action('actionSelectMajorUnpaged', { namespace: 'requirement' })
  private actionSelectMajorUnpaged: any;
  @Action('actionResetCandidate', { namespace: 'candidate' })
  private actionResetCandidate: any;

  // MUTATION
  @Mutation('mutationCandidateVerify', { namespace: 'candidate' })
  private mutationCandidateVerify: any;

  // STATE
  @State('array_candidate_inactive', { namespace: 'candidate' })
  private array_candidate: [];
  @State('pagination_candidate_inactive', { namespace: 'candidate' })
  private pagination_candidate: any;
  @State('array_major', { namespace: 'requirement' })
  private array_major: any;
  @State('candidate', { namespace: 'candidate' })
  private candidate: any;
  @State('locale')
  private locale: any;

  /* INITIALIZATION */

  private skills: string[] = [];
  private isShowAddSkill: boolean = false;
  private isEditCandiate: boolean = false;
  private workingStatus: string[] = [
    'Employed', 'Unemployed',
  ];
  private verificationStatus: string[] = [
    'Verified', 'Unverified',
  ];

  constructor() {
    super();
  }

  @Watch('isEditCandiate')
  public onChangeisEditCandiate() {
    this.actionSelectCandidateInactive();
  }

  /* LIFECYCLE */

  private created() {
    this.actionResetCandidate();
    this.actionSelectMajorUnpaged();
    this.clickSearch();

    const currentRoute = this.$router.currentRoute;
    if (currentRoute.meta.editCandiate) {
      const currentEditCandidate: any = this.array_candidate.filter((candidate: any) => {
        return candidate.id === currentRoute.params.id;
      });
      if (currentEditCandidate.length > 0) {
        this.editCandidate(currentEditCandidate[0]);
      }
    }
  }

  /* METHOD */

  private editCandidate(candidate: any) {
    if (!candidate.phone) { candidate.phone = ' '; }
    this.mutationCandidateVerify(candidate);
    this.isEditCandiate = true;
  }

  private clickSearch() {
    this.actionSelectCandidateInactive();
  }

  private clickDetail(candidate: any) {
    this.$router.push({name: 'candidateDetail', params: { id: candidate.id}});
  }

  private clickPage(page: number, url: string) {
    if (url) {
      this.actionPaginationCandidate({url, page});
    } else {
      this.clickSearch();
    }
  }

  private removeSkill(value: string) {
    const index = this.skills.indexOf(value);
    if (index > -1) {
      this.skills.splice(index, 1);
    }
  }

  private getLabel(label: string): string {
    if (this.locale === 'id') {
      return 'translation';
    }
    return label;
  }
}
